// Angular import
import { Component, ElementRef, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

// project import
import { SharedModule } from 'src/app/theme/shared/shared.module';

// third party
import { TranslateService } from '@ngx-translate/core';
import screenfull from 'screenfull';
import { NgbModal,ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'src/app/theme/shared/components/modal/modal.module';
import { AppConfig } from 'src/app/app-config';
import { AuthService } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/services/toast.service';
import { AuthGuard } from 'src/app/guards/auth.guard';

@Component({
  selector: 'app-nav-right',
  standalone: true,
  imports: [SharedModule, RouterModule,ModalModule],
  templateUrl: './nav-right.component.html',
  styleUrl: './nav-right.component.scss'
})
export class NavRightComponent implements OnInit {
  user?: null;
  screenFull: boolean = true;
  confirmLogout: any;
  closeResult = '';
  nombreUser: any | null;
  rolUser: any | null;

  constructor(private auth:AuthGuard,private toastService:ToastService,private authService: AuthService,private translate: TranslateService,private modalService: NgbModal) {}

  ngOnInit() {
    this.nombreUser = localStorage.getItem('user_name');
    this.rolUser = localStorage.getItem('user_role')
    setTimeout(() => {
      this.useLanguage(AppConfig.i18n);
    }, 0);
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

  // public props
  componentSections = [
    {
      title: 'UI Components',
      items: [
        {
          title: 'Alerts'
        },
        {
          title: 'Accordions'
        },
        {
          title: 'DropDown'
        },
        {
          title: 'Badges'
        },
        {
          title: 'Breadcrumbs'
        }
      ]
    },
    {
      title: 'Application',
      items: [
        {
          title: 'Chat'
        },
        {
          title: 'Kanban'
        },
        {
          title: 'Mail'
        },
        {
          title: 'Calendar'
        },
        {
          title: 'E-Commerce'
        }
      ]
    },
    {
      title: 'Components',
      items: [
        {
          title: 'Sweet Alert'
        },
        {
          title: 'Light Box'
        },
        {
          title: 'Modal'
        },
        {
          title: 'Notification'
        },
        {
          title: 'Tree View'
        }
      ]
    }
  ];
  notification = [
    {
      images: 'assets/images/user/avatar-2.jpg',
      background: 'bg-light-success',
      icon: 'ti ti-building-store',
      title: 'John Doe',
      time: '2 min ago',
      text: 'It is a long established fact that a reader will be distracted',
      badgeType: true,
      mailType: false,
      imagesType: false,
      conformation: false,
      iconType: false
    },
    {
      images: 'assets/images/user/avatar-2.jpg',
      background: 'bg-light-success',
      icon: 'ti ti-building-store',
      title: 'Store Verification Done',
      time: '3 min ago',
      text: 'We have successfully received your request.',
      badgeType: true,
      mailType: false,
      imagesType: false,
      conformation: false,
      iconType: true
    },
    {
      images: 'assets/images/user/avatar-2.jpg',
      background: 'bg-light-primary',
      icon: 'ti ti-mailbox',
      title: 'Check Your Mail.',
      time: '5 min ago',
      text: "All done! Now check your inbox as you're in for a sweet treat!",
      badgeType: false,
      mailType: true,
      imagesType: false,
      conformation: false,
      iconType: true
    },
    {
      images: 'assets/images/user/avatar-2.jpg',
      background: 'bg-light-success',
      icon: 'ti ti-building-store',
      title: 'John Doe',
      time: '8 min ago',
      text: 'Uploaded two file on 21Jan 2020',
      badgeType: false,
      mailType: false,
      imagesType: true,
      conformation: false,
      iconType: false
    },
    {
      images: 'assets/images/user/avatar-3.jpg',
      background: 'bg-light-success',
      icon: 'ti ti-building-store',
      title: 'John Doe',
      time: '10 min ago',
      text: 'It is a long established fact that a reader will be distracted',
      badgeType: false,
      mailType: false,
      imagesType: false,
      conformation: true,
      iconType: false
    }
  ];

  toggleFullscreen() {
    this.screenFull = screenfull.isFullscreen;
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  } 

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  openMyModal(event: string) {
    document.querySelector('#' + event)?.classList.add('md-show');
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  close(){
    const userEmail = localStorage.getItem('user_email') || ''; 

    this.authService.logoutApp(userEmail).subscribe({
      next: (response) => {
        this.toastService.show(response.message, 'success');
        localStorage.clear();
        this.auth.canActivate();
      },
      error: (error) => {
        this.toastService.show(error.error.Message, 'danger');
      },
    });
    this.modalService.dismissAll();
  }
}
